import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  container: {
    padding: '20px',
    background: 'white',
    boxSizing: 'border-box',
    margin: '40px',
    borderRadius: '10px',
    [theme.breakpoints.down('sm')]: {
      margin: '20px',
      padding: '15px',
    },
  },
  form: {
    minWidth: '650px',
    [theme.breakpoints.down('sm')]: {
      minWidth: '100%',
    },
  },
  usersContainer: {
    maxHeight: '500px',
    overflow: 'auto',
    margin: '10px 0px',
  },
  searchContainer: {
    width: '100%',
    padding: '20px',
    boxSizing: 'border-box',
    [theme.breakpoints.down('sm')]: {
      padding: '10px',
    },
  },
  userRow: {
    display: 'grid',
    alignItems: 'center',
    gridTemplateColumns: '250px 1fr',
    [theme.breakpoints.down('md')]: {
      gridTemplateColumns: '200px 1fr',
    },
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
      gap: '10px',
    },
  },
  userPhones: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '10px',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'flex-start',
    },
  },
  phoneItem: {
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  noPhones: {
    color: 'red',
    margin: '0px 15px',
    [theme.breakpoints.down('sm')]: {
      margin: '10px 0',
    },
  },
}));

export default useStyles; 